export enum SupportTicketStatus {
  Open = "OPEN",
  Closed = "CLOSED",
  Snoozed = "SNOOZED",
  InProgress = "IN_PROGRESS",
  Hidden = "HIDDEN",
  Archived = "ARCHIVED",
  Deleted = "DELETED",
  Draft = "DRAFT",
}
